import { ReactNode } from 'react';
import { SimplifiedStepSection } from '@quicktools/shared-components';
import { IStep } from '@quicktools/shared-components/components/landingPages/SimplifiedStepSection';
import { useTranslation } from 'react-i18next';

export interface IHowToSection {
  cta: ReactNode;
}

function HowToSection({ cta }: IHowToSection) {
  const { t } = useTranslation();
  const steps: IStep[] = [0, 1, 2].map((index) => ({
    title: t(`home.howToSection.steps.${index}.title`),
    description: t(`home.howToSection.steps.${index}.description`),
  }));

  return <SimplifiedStepSection cta={cta} title={t('home.howToSection.title')} steps={steps} />;
}

export default HowToSection;
